/**
 * @file: 商品不陈列标签渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as FrontCubeData from '../../../frontCubeData/index';

export function renderDisplayTag(cube: CubeNode): void {
    let tagValue: number = FrontCubeData.getValue(cube.id, 'wareDisplayFlag');
    let $tag: JQuery<HTMLElement> = cube.jView.find('.not-display');

    if (tagValue + '' === '0') {
        $tag.addClass('show-not-display');
        return;
    }

    $tag.removeClass('show-not-display');
}
